export default "__VITE_ASSET__ICinqEb3__"